<script>
export default {
    name: "CaretRight"
}
</script>
<template>
    <svg role="img" aria-label="Caret Right"  viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L1 9" stroke="white" stroke-width="2"/>
    </svg>
</template>
